import UserController, { User } from "@/controller/user";
import AuthModel from "@/models/auth";

export const LOCAL_STORAGE_KEY = "olv_auth";
export const USER_PROFILE = "olv_user_profile";

export default class AuthController {
  public static isAuth(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY);
  }

  public static clearAuth() {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }

  public static setIsAuth(userUid: string) {
    localStorage.setItem(LOCAL_STORAGE_KEY, userUid);
  }

  public static getUserUid(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY) || null;
  }

  public static getUserProfile(): User | null {
    const userJson = localStorage.getItem(USER_PROFILE);

    if (!userJson) {
      return null;
    }

    return JSON.parse(userJson);
  }

  public static async register(phone: string, password: string) {
    await AuthModel.register(phone, password);
    await this.setUserProfile(phone);
  }

  private static async setUserProfile(phone: string) {
    const userController = new UserController(phone);
    const user: User = await userController.getUserProfile();
    localStorage.setItem(USER_PROFILE, JSON.stringify(user));
  }

  public static async logIn(phone: string, password: string) {
    await AuthModel.logIn(phone, password);
    await this.setUserProfile(phone);
  }

  public static logOut() {
    return AuthModel.logOut();
  }

  public static getFirebaseAuth() {
    return AuthModel.getFirebaseAuth();
  }
}
